import React, { useEffect } from 'react';
import { Card } from '../ui/Card';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
import { mockOrganizations, mockStores } from '../../utils/mockData';
import { useWizard } from '../../hooks/useWizard';
import { generateStoreSlug } from '../../utils/slugify';
export function WizardStep1Setup() {
  const {
    data,
    updateStep1
  } = useWizard();
  const step1Data = data.step1;
  // Auto-generate slug from store name
  useEffect(() => {
    if (step1Data.storeName && !step1Data.slug) {
      const existingSlugs = mockStores.map(s => s.slug);
      const generatedSlug = generateStoreSlug(step1Data.storeName, existingSlugs);
      updateStep1({
        slug: generatedSlug
      });
    }
  }, [step1Data.storeName]);
  return <Card title="Store Setup" description="Basic information about the pop-up store." data-id="element-450">
      <div className="space-y-6" data-id="element-451">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2" data-id="element-452">
          <div className="col-span-2" data-id="element-453">
            <Input label="Store Name *" placeholder="e.g. Lincoln High Football Fall 2024" value={step1Data.storeName} onChange={e => updateStep1({
            storeName: e.target.value
          })} data-id="element-454" />
          </div>

          <Select label="Organization *" value={step1Data.organizationId} onChange={e => updateStep1({
          organizationId: e.target.value
        })} options={[{
          value: '',
          label: 'Select Organization...'
        }, ...mockOrganizations.map(o => ({
          value: o.id,
          label: o.name
        }))]} data-id="element-455" />

          <Input label="URL Slug *" placeholder="lincoln-football-fall-24" helperText="Auto-generated from name. Used in storefront URL." value={step1Data.slug} onChange={e => updateStep1({
          slug: e.target.value
        })} data-id="element-456" />

          <Input label="Support Email *" type="email" placeholder="support@printer.com" value={step1Data.supportEmail} onChange={e => updateStep1({
          supportEmail: e.target.value
        })} data-id="element-457" />

          <Input label="Support Phone" type="tel" placeholder="(555) 123-4567" value={step1Data.supportPhone} onChange={e => updateStep1({
          supportPhone: e.target.value
        })} data-id="element-458" />

          <div className="col-span-2" data-id="element-459">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-460">
              Internal Notes (Admin Only)
            </label>
            <textarea className="w-full rounded-md border border-gray-300 p-2 text-sm focus:ring-red-500 focus:border-red-500" rows={3} value={step1Data.internalNotes} onChange={e => updateStep1({
            internalNotes: e.target.value
          })} placeholder="Internal notes for admin reference..." data-id="element-461" />
          </div>

          {step1Data.slug && <div className="col-span-2 p-3 bg-blue-50 border border-blue-200 rounded-md" data-id="element-462">
              <p className="text-xs font-medium text-blue-900 mb-1" data-id="element-463">
                Storefront URL Preview
              </p>
              <p className="text-sm text-blue-700 font-mono break-all" data-id="element-464">
                https://stores.printer.com/store/{step1Data.slug}
              </p>
            </div>}
        </div>
      </div>
    </Card>;
}